import { Descriptions, Select } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import Button from '../../Button';
import useNotification from '../../../hooks/useNotification';
import { ITestType } from '../../../models/testCenter.model';
import { RootState } from '../../../store/rootReducer';
import useAuth from '../../../hooks/useAuth';
import SelectEduStep from '../../SelectEduStep';

interface IProps {
  type: ITestType | null | undefined;
  onSubmit: (req: any) => void;
}

const TypeEditor: FC<IProps> = ({
  type,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryEduStepCode = searchParams.get('eduStepCode');
  const { infoNotification } = useNotification();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // TE0001 = 시험구분
  const TE0001 = commonCodes.find(item => item.commonCode === 'TE0001')?.detailCode;

  const [eduStepCode, setEduStepCode] = useState<string>();
  const [examDiv, setExamDiv] = useState<string>();
  const [examTypeName, setExamTypeName] = useState('');
  const [memo, setMemo] = useState('');

  useEffect(() => {
    if (!type && queryEduStepCode) {
      setEduStepCode(queryEduStepCode);
    }
  }, [queryEduStepCode]);

  useEffect(() => {
    if (type) {
      setEduStepCode(type.eduStepCode);
      setExamDiv(type.examDiv);
      setExamTypeName(type.examTypeName);
      setMemo(type.memo);
    }
  }, [type]);

  const onSave = () => {
    if (!examDiv) {
      return infoNotification(t('cbt.type.message5'));
    }
    if (!examTypeName) {
      return infoNotification(t('cbt.type.message6'));
    }

    onSubmit({
      eduStepCode,
      examDiv,
      examTypeName,
      memo,
    });
  }

  return (
    <>
      <div className='comm-table__area rowType'>
        <Descriptions bordered column={1}>
          <Descriptions.Item label={t('common.label.1')}>
            <SelectEduStep
              eduStepCode={eduStepCode}
              setEduStepCode={value => {
                setEduStepCode(value);
                setExamDiv(undefined);
              }}
              width={150}
              disabled={!!type}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('cbt.type.column8')}>
            <div className="w-150p">
              <Select
                className="w-100"
                placeholder={t('common.button.select')}
                value={examDiv}
                onChange={value => setExamDiv(value)}
                disabled={type ? true : false}
              >
                {
                  TE0001
                    ?.filter(item => item.detailCode !== 'OC')
                    ?.map(item => {
                      if (item.additionInfo1 === eduStepCode || item.additionInfo2 === eduStepCode) {
                        return (
                          <Select.Option
                            key={item.detailCode}
                            value={item.detailCode}
                          >
                            {item.korName}
                          </Select.Option>
                        );
                      } else {
                        return null;
                      }
                    })
                }
              </Select>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('cbt.type.column2')}>
            <input
              className="form-control"
              type="text"
              value={examTypeName}
              onChange={e => setExamTypeName(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('cbt.type.column4')}>
            <input
              className="form-control"
              type="text"
              value={memo}
              onChange={e => setMemo(e.target.value)}
            />
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className='btn-basic gray-line'
            onClick={() => history.push(`/cbt/type?eduStepCode=${type?.eduStepCode || eduStepCode}`)}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className='btn-basic pink'
            onClick={onSave}
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
            // test용 해제
            // disabled
          />
        </div>
      </div>
    </>
  );
}

export default TypeEditor;
